import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import saleReturnService from "../../../services/saleReturnService";

const initialState = {
  returns:          [],
  singleReturn:     null,
  returnableItems:  null, // { sale, returnableItems[] }
  isLoading:        false,
  error:            null,
};

export const createReturn = createAsyncThunk(
  "saleReturn/create",
  async (data, t) => {
    try { return await saleReturnService.createReturn(data); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

export const getReturns = createAsyncThunk(
  "saleReturn/getAll",
  async (params, t) => {
    try { return await saleReturnService.getReturns(params); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

export const getSingleReturn = createAsyncThunk(
  "saleReturn/getSingle",
  async (id, t) => {
    try { return await saleReturnService.getSingleReturn(id); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

export const getReturnableItems = createAsyncThunk(
  "saleReturn/getReturnableItems",
  async (saleId, t) => {
    try { return await saleReturnService.getReturnableItems(saleId); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

const saleReturnSlice = createSlice({
  name: "saleReturn",
  initialState,
  reducers: {
    clearReturnableItems: (state) => { state.returnableItems = null; },
    clearReturns:         (state) => { state.returns = []; },
  },
  extraReducers: (builder) => {
    builder
      // create
      .addCase(createReturn.pending,    (state) => { state.isLoading = true; })
      .addCase(createReturn.fulfilled,  (state, action) => {
        state.isLoading = false;
        state.returns.unshift(action.payload);
        toast.success("Return processed successfully");
      })
      .addCase(createReturn.rejected,   (state, action) => {
        state.isLoading = false;
        toast.error(action.payload);
      })
      // getAll
      .addCase(getReturns.pending,      (state) => { state.isLoading = true; })
      .addCase(getReturns.fulfilled,    (state, action) => {
        state.isLoading = false;
        state.returns = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(getReturns.rejected,     (state) => { state.isLoading = false; })
      // getSingle
      .addCase(getSingleReturn.fulfilled, (state, action) => {
        state.singleReturn = action.payload;
      })
      // getReturnableItems
      .addCase(getReturnableItems.pending,   (state) => { state.isLoading = true; })
      .addCase(getReturnableItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.returnableItems = action.payload;
      })
      .addCase(getReturnableItems.rejected,  (state, action) => {
        state.isLoading = false;
        toast.error(action.payload);
      });
  },
});

export const { clearReturnableItems, clearReturns } = saleReturnSlice.actions;
export default saleReturnSlice.reducer;